// ======================================================================
// FILE:
// src/modules/service_crm/tickets/pages/ServiceTicketDetailPage.js
//
// MODULE: Service CRM
// FEATURE: Service Ticket Detail View
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import FormSectionCard
from "../../components/FormSectionCard";

import serviceTicketService
from "../../services/serviceTicketService";

import CustomerFeedbackSection
from "../components/CustomerFeedbackSection";

import ServiceTicketTabView
from "../components/ServiceTicketTabView";

export default function ServiceTicketDetailPage() {

  const navigate = useNavigate();

  const { id } = useParams();

  const [searchParams] =
  useSearchParams();

const readOnly =
  searchParams.get("readonly") === "1";

const source =
  searchParams.get("source");

  console.log({
  readOnly,
  source
});

  // -------------------------------------------------------------------
  // STATE
  // -------------------------------------------------------------------
  const [loading, setLoading] =
    useState(true);

  const [row, setRow] =
    useState(null);

  const [timeline, setTimeline] =
    useState([]);

  const [visits, setVisits] =
  useState([]);

const [visitForm, setVisitForm] =
  useState({

     engineer_name: null,

    running_hours: "",

    work_done: "",

    observations: "",

    parts_used: "",

    next_visit_required: false,
  });

const [savingVisit, setSavingVisit] =
  useState(false);  

// -------------------------------------------------------------------
// VIEW MODE
// -------------------------------------------------------------------
const [viewMode, setViewMode] =
  useState("classic");

const [activeTab, setActiveTab] =
  useState("overview");  
  // -------------------------------------------------------------------
  // LOAD
  // -------------------------------------------------------------------
  useEffect(() => {

    loadData();

  }, [id]);

  // -------------------------------------------------------------------
  // LOAD DATA
  // -------------------------------------------------------------------
  async function loadData() {

    try {

      setLoading(true);

      const ticket =
        await serviceTicketService
          .getTicket(id);

      const timelineRows =
        await serviceTicketService
          .getTimeline(id);
      
      const visitRows =
        await serviceTicketService
            .listVisits(id);    

      setRow(ticket);
      console.log(row);
      setVisitForm(prev => ({

        ...prev,

        engineer_name:
          ticket.assigned_engineer || ""

      }));

      setTimeline(
        timelineRows || []
      );

      setVisits(
        visitRows || []
        );

    } catch (err) {

      console.error(err);

      alert(
        "Failed to load ticket"
      );

    } finally {

      setLoading(false);
    }
  }

  // -------------------------------------------------------------------
  // STATUS BADGE
  // -------------------------------------------------------------------
  function renderStatus(status) {

    const value =
      (status || "").toUpperCase();

    let bg = "#6c757d";

    if (value === "OPEN") {
      bg = "#dc3545";
    }

    else if (
      value === "ASSIGNED"
    ) {
      bg = "#fd7e14";
    }

    else if (
      value === "IN_PROGRESS"
    ) {
      bg = "#0d6efd";
    }

    else if (
      value === "RESOLVED"
    ) {
      bg = "#198754";
    }

    else if (
      value === "CLOSED"
    ) {
      bg = "#212529";
    }

    return (

      <span
        style={{

          background: bg,

          color: "#fff",

          padding:
            "6px 12px",

          borderRadius: 20,

          fontSize: 13,

          fontWeight: 600,
        }}
      >
        {status}
      </span>
    );
  }

  // -------------------------------------------------------------------
  // FIELD
  // -------------------------------------------------------------------
  const Field = ({
    label,
    value,
  }) => (

    <div>

      <div
        style={{

          fontSize: 12,

          color: "#6c757d",

          marginBottom: 4,

          fontWeight: 600,
        }}
      >
        {label}
      </div>

      <div
        style={{

          fontSize: 14,

          fontWeight: 500,

          minHeight: 24,
        }}
      >
        {value || "-"}
      </div>

    </div>
  );

  // -------------------------------------------------------------------
  // GRID STYLE
  // -------------------------------------------------------------------
  const gridStyle = {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(240px, 1fr))",

    gap: 18,
  };

  // -------------------------------------------------------------------
  // RESOLVE
  // -------------------------------------------------------------------
  async function handleResolve() {

    const remarks = prompt(
      "Enter resolution summary"
    );

    if (!remarks) return;

    try {

      await serviceTicketService
        .resolveTicket(
          id,
          {
            resolution_summary:
              remarks,
          }
        );

      alert(
        "Ticket resolved successfully"
      );

      loadData();

    } catch (err) {

      console.error(err);

      alert(
        "Failed to resolve ticket"
      );
    }
  }

  // -------------------------------------------------------------------
  // CLOSE
  // -------------------------------------------------------------------
  async function handleClose() {

    const remarks = prompt(
      "Enter closure remarks"
    );

    if (!remarks) return;

    try {

      await serviceTicketService
        .closeTicket(
          id,
          {
            closure_remarks:
              remarks,
          }
        );

      alert(
        "Ticket closed successfully"
      );

      loadData();

    } catch (err) {

      console.error(err);

      alert(
        "Failed to close ticket"
      );
    }
  }
// -------------------------------------------------------------------
// VISIT CHANGE
// -------------------------------------------------------------------
function handleVisitChange(e) {

  const {
    name,
    value,
    type,
    checked,
  } = e.target;

  setVisitForm({

    ...visitForm,

    [name]:
      type === "checkbox"
        ? checked
        : value,
  });
}


// -------------------------------------------------------------------
// ADD VISIT
// -------------------------------------------------------------------
async function handleAddVisit() {

  try {

    if (
      !visitForm.engineer_name
    ) {

      alert(
        "Engineer name required"
      );

      return;
    }

    if (
      !visitForm.work_done
    ) {

      alert(
        "Work done required"
      );

      return;
    }

    setSavingVisit(true);

    await serviceTicketService
      .addVisit(
        id,
        visitForm
      );

    alert(
      "Visit added successfully"
    );

    setVisitForm({

      engineer_name: row.assigned_engineer || "",

      running_hours: "",

      work_done: "",

      observations: "",

      parts_used: "",

      next_visit_required: false,
    });

    loadData();

  } catch (err) {

    console.error(err);

    alert(
      "Failed to add visit"
    );

  } finally {

    setSavingVisit(false);
  }
}
// -------------------------------------------------------------------
// TAB RENDERERS
// -------------------------------------------------------------------

function renderOverviewTab() {

  return (

    <div>

      <FormSectionCard
        title="Ticket Overview"
        collapsible
        defaultExpanded={true}
      >

        <div style={gridStyle}>

          <Field
            label="Ticket No"
            value={row.ticket_no}
          />

          <Field
            label="SR Type"
            value={row.sr_type}
          />

          <Field
            label="Priority"
            value={row.priority}
          />

          <Field
            label="Category"
            value={row.category}
          />

          <Field
            label="Status"
            value={row.status}
          />

          <Field
            label="Created At"
            value={row.created_at}
          />

        </div>

      </FormSectionCard>
      <FormSectionCard
        title="Installed Product"
        collapsible
        defaultExpanded={true}
      >

        
        <div style={gridStyle}>

          <Field
            label="Instance ID"
            value={row.instance_id}
          />

          <Field
            label="App Code"
            value={row.app_code}
          />

          <Field
            label="Serial No"
            value={row.engine_serial_no}
          />

          <Field
            label="Customer"
            value={row.customer_name}
          />

          <Field
            label="Contact Person"
            value={row.contact_person}
          />

          <Field
            label="Contact Number"
            value={row.contact_number}
          />

          <Field
            label="State"
            value={row.state}
          />

          <Field
            label="City"
            value={row.city}
          />
          <Field
            label="Address"
            value={row.site_address}
          />

        </div>

      </FormSectionCard>
      <FormSectionCard
        title="Complaint Details"
        collapsible
        defaultExpanded={true}
      >

        <div
          style={{
            marginBottom: 20,
          }}
        >

          <div
            style={{
              fontSize: 12,
              color: "#6c757d",
              marginBottom: 6,
              fontWeight: 600,
            }}
          >
            VOC / Complaint
          </div>

          <div
            style={{
              background: "#f8f9fa",
              borderRadius: 10,
              padding: 14,
              minHeight: 80,
            }}
          >
            {row.voc_details || "-"}
          </div>

        </div>

        <div>

          <div
            style={{
              fontSize: 12,
              color: "#6c757d",
              marginBottom: 6,
              fontWeight: 600,
            }}
          >
            Additional Notes
          </div>

          <div
            style={{
              background: "#f8f9fa",
              borderRadius: 10,
              padding: 14,
              minHeight: 80,
            }}
          >
            {row.complaint_details || "-"}
          </div>

        </div>

      </FormSectionCard>
     <FormSectionCard
      title="Assignment"
      collapsible
      defaultExpanded={true}
    >

      <div style={gridStyle}>

        <Field
          label="Engineer"
          value={row.assigned_engineer}
        />

        <Field
          label="Dealer"
          value={row.assigned_dealer}
        />

        <Field
          label="Plant"
          value={row.assigned_plant}
        />

        <Field
          label="Assigned At"
          value={row.assigned_at}
        />

      </div>

    </FormSectionCard>       
    </div>
  );
}


function renderOperationsTab() {

  return (

    <div>

      <FormSectionCard
        title="Service Visits"
        collapsible
        defaultExpanded={true}
      >

        <div>

          <div
            style={{
              marginBottom: 10,
              fontWeight: 600,
            }}
          >
            Total Visits: {visits.length}
          </div>

          {visits.length === 0 && (

            <div>
              No visits added
            </div>
          )}

          {visits.map((v) => (

            <div
              key={v.id}

              style={{

                border:
                  "1px solid #dee2e6",

                borderRadius: 12,

                padding: 16,

                marginBottom: 12,
              }}
            >

              <div
                style={{
                  fontWeight: 700,
                  marginBottom: 6,
                }}
              >
                {v.visit_no}
              </div>

              <div
                style={{
                  color: "#6c757d",
                  marginBottom: 10,
                }}
              >
                {v.visit_datetime}
              </div>

              <div style={gridStyle}>

                <Field
                  label="Engineer"
                  value={v.engineer_name}
                />

                <Field
                  label="Running Hours"
                  value={v.running_hours}
                />

                <Field
                  label="Next Visit"
                  value={
                    v.next_visit_required
                      ? "YES"
                      : "NO"
                  }
                />

              </div>

            </div>
          ))}

        </div>

        {(row.status === "RESOLVED"
          ||
          row.status === "CLOSED")
          && (

          <FormSectionCard
            title="Resolution"
            collapsible
            defaultExpanded={true}
          >

            <div style={gridStyle}>

              <Field
                label="Resolved At"
                value={row.resolved_at}
              />

              <Field
                label="Resolved By"
                value={row.resolved_by}
              />

            </div>

            <div
              style={{
                marginTop: 20,
              }}
            >

              <div
                style={{
                  fontSize: 12,
                  color: "#6c757d",
                  marginBottom: 6,
                  fontWeight: 600,
                }}
              >
                Resolution Summary
              </div>

              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: 10,
                  padding: 14,
                  minHeight: 80,
                }}
              >
                {row.resolution_summary || "-"}
              </div>

            </div>

          </FormSectionCard>
        )}
        {row.status === "CLOSED"
          && (

          <FormSectionCard
            title="Closure"
            collapsible
            defaultExpanded={true}
          >

            <div style={gridStyle}>

              <Field
                label="Closed At"
                value={row.closed_at}
              />

              <Field
                label="Closed By"
                value={row.closed_by}
              />

            </div>

            <div
              style={{
                marginTop: 20,
              }}
            >

              <div
                style={{
                  fontSize: 12,
                  color: "#6c757d",
                  marginBottom: 6,
                  fontWeight: 600,
                }}
              >
                Closure Remarks
              </div>

              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: 10,
                  padding: 14,
                  minHeight: 80,
                }}
              >
                {row.closure_remarks || "-"}
              </div>

            </div>

          </FormSectionCard>
        )}  
      </FormSectionCard>

    </div>
  );
}


function renderExperienceTab() {

  return (

    <div>

      {(row.status === "RESOLVED"
        ||
        row.status === "CLOSED")
        && (

        <CustomerFeedbackSection

          ticketId={row.id}

          ticketStatus={row.status}

          onSaved={loadData}
        />
      )}

    </div>
  );
}


function renderTimelineTab() {

  return (

    <FormSectionCard
      title="Timeline"
      collapsible
      defaultExpanded={true}
    >

      {timeline.length === 0 && (

        <div>
          No timeline entries
        </div>
      )}

      {timeline.map((t) => (

        <div
          key={t.id}

          style={{

            borderLeft:
              "3px solid #0d6efd",

            paddingLeft: 14,

            marginBottom: 20,
          }}
        >

          <div
            style={{

              fontWeight: 700,

              marginBottom: 4,
            }}
          >
            {t.action_type}
          </div>

          <div
            style={{

              fontSize: 13,

              color: "#6c757d",

              marginBottom: 4,
            }}
          >
            {t.action_at}
          </div>

          <div
            style={{
              marginBottom: 4,
            }}
          >

            {t.old_status
              && (
                <>
                  {t.old_status}
                  {" → "}
                </>
              )}

            {t.new_status}

          </div>

          <div>
            {t.remarks || "-"}
          </div>

        </div>
      ))}

    </FormSectionCard>
  );
} 


// -------------------------------------------------------------------
  // LOADING
  // -------------------------------------------------------------------
  if (loading) {

    return (

      <div
        style={{
          padding: 40,
        }}
      >
        Loading ticket...
      </div>
    );
  }

  // -------------------------------------------------------------------
  // NO DATA
  // -------------------------------------------------------------------
  if (!row) {

    return (

      <div
        style={{
          padding: 40,
        }}
      >
        Ticket not found
      </div>
    );
  }

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div>

      {/* ========================================================= */}
      {/* HEADER */}
      {/* ========================================================= */}

      <div
        style={{

          background:
            "linear-gradient(90deg, #0d6efd, #3d8bfd)",

          borderRadius: 14,

          padding: "18px 22px",

          color: "#fff",

          marginBottom: 20,

          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",

          flexWrap: "wrap",

          gap: 16,
        }}
      >

        {/* LEFT */}
        <div>

          <div
            style={{

              fontSize: 24,

              fontWeight: 700,
            }}
          >
            {row.ticket_no}
          </div>

          <div
            style={{
              marginTop: 4,
            }}
          >
            {row.customer_name}
          </div>

        </div>

        {/* RIGHT */}
        <div
          style={{

            display: "flex",

            gap: 10,

            flexWrap: "wrap",

            alignItems: "center",
          }}
        >

          {renderStatus(
            row.status
          )}

          {/* EDIT */}
          {!readOnly && (
          <button
            className="btn btn-light"

            onClick={() =>
              navigate(
                `/service-crm/tickets/${row.id}/edit`
              )
            }
          >
            Edit
          </button>
          )}

          {/* RESOLVE */}
          {!readOnly &&
            row.status !== "RESOLVED" &&
            row.status !== "CLOSED" && (

              <button
                className="btn btn-success"
                onClick={handleResolve}
              >
                Resolve
              </button>
          )}

          {/* CLOSE */}
          {row.status === "RESOLVED"
            && (

            <button
              className="btn btn-warning"

              onClick={
                handleClose
              }
            >
              Close
            </button>
          )}

          {/* VIEW TOGGLE */}
          <div
            style={{

              display: "flex",

              border:
                "1px solid rgba(255,255,255,0.4)",

              borderRadius: 10,

              overflow: "hidden",
            }}
          >

            {/* CLASSIC */}
            <button
              type="button"

              onClick={() =>
                setViewMode("classic")
              }

              style={{

                border: "none",

                padding:
                  "8px 14px",

                background:
                  viewMode === "classic"
                    ? "#fff"
                    : "transparent",

                color:
                  viewMode === "classic"
                    ? "#0d6efd"
                    : "#fff",

                fontWeight: 600,

                cursor: "pointer",
              }}
            >
              Classic
            </button>

            {/* TAB */}
            <button
              type="button"

              onClick={() =>
                setViewMode("tabs")
              }

              style={{

                border: "none",

                padding:
                  "8px 14px",

                background:
                  viewMode === "tabs"
                    ? "#fff"
                    : "transparent",

                color:
                  viewMode === "tabs"
                    ? "#0d6efd"
                    : "#fff",

                fontWeight: 600,

                cursor: "pointer",
              }}
            >
              Tabs
            </button>

          </div>
          
          {/* BACK */}
<button
  className="btn btn-outline-light"
  onClick={() => {

    if (source === "visits") {

      navigate(
        "/service-crm/visits"
      );

      return;
    }

    navigate(
      "/service-crm/tickets"
    );

  }}
>
  Back
</button>

        </div>

      </div>

      {/* ========================================================= */}
{/* TAB VIEW */}
{/* ========================================================= */}

{viewMode === "tabs"
  && (

  <ServiceTicketTabView

    activeTab={activeTab}

    setActiveTab={setActiveTab}

    renderOverview={
      renderOverviewTab
    }

    renderOperations={
      renderOperationsTab
    }

    renderExperience={
      renderExperienceTab
    }

    renderTimeline={
      renderTimelineTab
    }
  />
)}      
      
{viewMode === "classic"
  && (

  <>     
      {/* ========================================================= */}
      {/* OVERVIEW */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Ticket Overview"
        collapsible
        defaultExpanded={true}
      >

        <div style={gridStyle}>

          <Field
            label="Ticket No"
            value={row.ticket_no}
          />

          <Field
            label="SR Type"
            value={row.sr_type}
          />

          <Field
            label="Priority"
            value={row.priority}
          />

          <Field
            label="Category"
            value={row.category}
          />

          <Field
            label="Status"
            value={row.status}
          />

          <Field
            label="Created At"
            value={row.created_at}
          />

        </div>

      </FormSectionCard>

      {/* ========================================================= */}
      {/* PRODUCT */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Installed Product"
        collapsible
        defaultExpanded={true}
      >

        <div style={gridStyle}>

          <Field
            label="Instance ID"
            value={row.instance_id}
          />

          <Field
            label="App Code"
            value={row.app_code}
          />

          <Field
            label="Serial No"
            value={
              row.engine_serial_no
            }
          />

          <Field
            label="Customer"
            value={
              row.customer_name
            }
          />

          <Field
            label="Contact Person"
            value={
              row.contact_person
            }
          />

          <Field
            label="Contact Number"
            value={
              row.contact_number
            }
          />

          <Field
            label="State"
            value={row.state}
          />

          <Field
            label="City"
            value={row.city}
          />

          <Field
            label="Address"
            value={row.site_address}
          />  

        </div>

      </FormSectionCard>

      {/* ========================================================= */}
      {/* COMPLAINT */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Complaint Details"
        collapsible
        defaultExpanded={true}
      >

        <div
          style={{
            marginBottom: 20,
          }}
        >

          <div
            style={{

              fontSize: 12,

              color: "#6c757d",

              marginBottom: 6,

              fontWeight: 600,
            }}
          >
            VOC / Complaint
          </div>

          <div
            style={{

              background: "#f8f9fa",

              borderRadius: 10,

              padding: 14,

              minHeight: 80,
            }}
          >
            {row.voc_details || "-"}
          </div>

        </div>

        <div>

          <div
            style={{

              fontSize: 12,

              color: "#6c757d",

              marginBottom: 6,

              fontWeight: 600,
            }}
          >
            Additional Notes
          </div>

          <div
            style={{

              background: "#f8f9fa",

              borderRadius: 10,

              padding: 14,

              minHeight: 80,
            }}
          >
            {row.complaint_details || "-"}
          </div>

        </div>

      </FormSectionCard>

      {/* ========================================================= */}
      {/* ASSIGNMENT */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Assignment"
        collapsible
        defaultExpanded={true}
      >

        <div style={gridStyle}>

          <Field
            label="Engineer"
            value={
              row.assigned_engineer
            }
          />

          <Field
            label="Dealer"
            value={
              row.assigned_dealer
            }
          />

          <Field
            label="Plant"
            value={
              row.assigned_plant
            }
          />

          <Field
            label="Assigned At"
            value={
              row.assigned_at
            }
          />

        </div>

      </FormSectionCard>

      {/* ========================================================= */}
      {/* RESOLUTION */}
      {/* ========================================================= */}

      {(row.status === "RESOLVED"
        ||
        row.status === "CLOSED")
        && (

        <FormSectionCard
          title="Resolution"
          collapsible
          defaultExpanded={true}
        >

          <div style={gridStyle}>

            <Field
              label="Resolved At"
              value={
                row.resolved_at
              }
            />

            <Field
              label="Resolved By"
              value={
                row.resolved_by
              }
            />

          </div>

          <div
            style={{
              marginTop: 20,
            }}
          >

            <div
              style={{

                fontSize: 12,

                color: "#6c757d",

                marginBottom: 6,

                fontWeight: 600,
              }}
            >
              Resolution Summary
            </div>

            <div
              style={{

                background: "#f8f9fa",

                borderRadius: 10,

                padding: 14,

                minHeight: 80,
              }}
            >
              {row.resolution_summary
                || "-"}
            </div>

          </div>

        </FormSectionCard>
      )}
      {/* ========================================================= */}
      {/* CUSTOMER FEEDBACK */}
      {/* ========================================================= */}

      {(row.status === "RESOLVED"
        ||
        row.status === "CLOSED")
        && (

        <CustomerFeedbackSection

          ticketId={row.id}

          ticketStatus={row.status}

          onSaved={loadData}
        />
      )}
      {/* ========================================================= */}
      {/* CLOSURE */}
      {/* ========================================================= */}

      {row.status === "CLOSED"
        && (

        <FormSectionCard
          title="Closure"
          collapsible
          defaultExpanded={true}
        >

          <div style={gridStyle}>

            <Field
              label="Closed At"
              value={
                row.closed_at
              }
            />

            <Field
              label="Closed By"
              value={
                row.closed_by
              }
            />

          </div>

          <div
            style={{
              marginTop: 20,
            }}
          >

            <div
              style={{

                fontSize: 12,

                color: "#6c757d",

                marginBottom: 6,

                fontWeight: 600,
              }}
            >
              Closure Remarks
            </div>

            <div
              style={{

                background: "#f8f9fa",

                borderRadius: 10,

                padding: 14,

                minHeight: 80,
              }}
            >
              {row.closure_remarks
                || "-"}
            </div>

          </div>

        </FormSectionCard>
      )}

      {/* ========================================================= */}
      {/* TIMELINE */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Timeline"
        collapsible
        defaultExpanded={true}
      >

        {timeline.length === 0 && (

          <div>
            No timeline entries
          </div>
        )}

        {timeline.map((t) => (

          <div
            key={t.id}

            style={{

              borderLeft:
                "3px solid #0d6efd",

              paddingLeft: 14,

              marginBottom: 20,
            }}
          >

            <div
              style={{

                fontWeight: 700,

                marginBottom: 4,
              }}
            >
              {t.action_type}
            </div>

            <div
              style={{

                fontSize: 13,

                color: "#6c757d",

                marginBottom: 4,
              }}
            >
              {t.action_at}
            </div>

            <div
              style={{
                marginBottom: 4,
              }}
            >

              {t.old_status
                && (
                  <>
                    {t.old_status}
                    {" → "}
                  </>
                )}

              {t.new_status}

            </div>

            <div>
              {t.remarks || "-"}
            </div>

          </div>
        ))}

      </FormSectionCard>
      {/* ========================================================= */}
        {/* VISITS */}
        {/* ========================================================= */}

        <FormSectionCard
        title="Service Visits"
        collapsible
        defaultExpanded={true}
        >

        {/* ------------------------------------------------------ */}
        {/* ADD VISIT */}
        {/* ------------------------------------------------------ */}

        {row.status !== "CLOSED"
            && (

            <div
            style={{

                background: "#f8f9fa",

                borderRadius: 12,

                padding: 16,

                marginBottom: 24,
            }}
            >

            <h5
                style={{
                marginBottom: 18,
                }}
            >
                Add Visit
            </h5>

            <div className="row">

                <div
                className="col-md-4 mb-3"
                >

                <label>
                  Assigned Service Provider
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={row.assigned_engineer || ""}
                  disabled
                />

                </div>

                <div
                className="col-md-4 mb-3"
                >

                <label>
                    Running Hours
                </label>

                <input
                    type="number"

                    className="form-control"

                    name="running_hours"

                    value={
                    visitForm.running_hours
                    }

                    onChange={
                    handleVisitChange
                    }
                />

                </div>

            </div>

            <div className="row">

                <div
                className="col-md-12 mb-3"
                >

                <label>
                    Work Done
                </label>

                <textarea
                    rows="3"

                    className="form-control"

                    name="work_done"

                    value={
                    visitForm.work_done
                    }

                    onChange={
                    handleVisitChange
                    }
                />

                </div>

                <div
                className="col-md-6 mb-3"
                >

                <label>
                    Observations
                </label>

                <textarea
                    rows="3"

                    className="form-control"

                    name="observations"

                    value={
                    visitForm.observations
                    }

                    onChange={
                    handleVisitChange
                    }
                />

                </div>

                <div
                className="col-md-6 mb-3"
                >

                <label>
                    Parts Used
                </label>

                <textarea
                    rows="3"

                    className="form-control"

                    name="parts_used"

                    value={
                    visitForm.parts_used
                    }

                    onChange={
                    handleVisitChange
                    }
                />

                </div>

            </div>

            <div
                style={{
                marginBottom: 16,
                }}
            >

                <label>

                <input
                    type="checkbox"

                    name="next_visit_required"

                    checked={
                    visitForm
                        .next_visit_required
                    }

                    onChange={
                    handleVisitChange
                    }

                    style={{
                    marginRight: 8,
                    }}
                />

                Next Visit Required

                </label>

            </div>

            <button
                className="btn btn-primary"

                disabled={savingVisit}

                onClick={
                handleAddVisit
                }
            >

                {savingVisit
                ? "Saving..."
                : "Add Visit"}

            </button>

            </div>
        )}

        {/* ------------------------------------------------------ */}
        {/* VISIT LIST */}
        {/* ------------------------------------------------------ */}

        {visits.length === 0 && (

            <div>
            No visits added
            </div>
        )}

        {visits.map((v) => (

            <div
            key={v.id}

            style={{

                border:
                "1px solid #dee2e6",

                borderRadius: 12,

                padding: 18,

                marginBottom: 18,
            }}
            >

            <div
                style={{

                display: "flex",

                justifyContent:
                    "space-between",

                alignItems: "center",

                marginBottom: 14,

                flexWrap: "wrap",

                gap: 10,
                }}
            >

                <div>

                <div
                    style={{

                    fontSize: 18,

                    fontWeight: 700,
                    }}
                >
                    {v.visit_no}
                </div>

                <div
                    style={{
                    color: "#6c757d",
                    }}
                >
                    {v.visit_datetime}
                </div>

                </div>

                <div>

                <span
                    style={{

                    background:
                        "#0d6efd",

                    color: "#fff",

                    padding:
                        "5px 10px",

                    borderRadius: 20,

                    fontSize: 12,
                    }}
                >
                    {v.engineer_name}
                </span>

                </div>

            </div>

            <div style={gridStyle}>

                <Field
                label="Running Hours"
                value={
                    v.running_hours
                }
                />

                <Field
                label="Next Visit"
                value={
                    v.next_visit_required
                    ? "YES"
                    : "NO"
                }
                />

            </div>

            <div
                style={{
                marginTop: 20,
                }}
            >

                <div
                style={{

                    fontSize: 12,

                    color: "#6c757d",

                    marginBottom: 6,

                    fontWeight: 600,
                }}
                >
                Work Done
                </div>

                <div
                style={{

                    background: "#f8f9fa",

                    borderRadius: 10,

                    padding: 14,

                    marginBottom: 16,
                }}
                >
                {v.work_done || "-"}
                </div>

                <div
                style={{

                    fontSize: 12,

                    color: "#6c757d",

                    marginBottom: 6,

                    fontWeight: 600,
                }}
                >
                Observations
                </div>

                <div
                style={{

                    background: "#f8f9fa",

                    borderRadius: 10,

                    padding: 14,

                    marginBottom: 16,
                }}
                >
                {v.observations || "-"}
                </div>

                <div
                style={{

                    fontSize: 12,

                    color: "#6c757d",

                    marginBottom: 6,

                    fontWeight: 600,
                }}
                >
                Parts Used
                </div>

                <div
                style={{

                    background: "#f8f9fa",

                    borderRadius: 10,

                    padding: 14,
                }}
                >
                {v.parts_used || "-"}
                </div>

            </div>

            </div>
        ))}

        </FormSectionCard>  
         </>
         )}
    </div>
  );
}